import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';

import { Box, Select, MenuItem, FormHelperText } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { genericApiToaster } from 'src/services/utils';

import { scrollbarStyle } from '../style';
import { useToast } from '../../hooks/useToast';
import { fetchForms } from '../../services/form.service';
import LinkGenerationOptions from './shareableFormOptions/LinkGenerationOptions';

function AddShareableForm({
  hideModal,
  handleFetchFormsSharableByGeneratedBy,
  row,
  mode,
}) {
  const [forms, setForms] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState(row ? row.form.id : ''); // Store the selected form ID
  const { showToast, hideToast } = useToast();
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();

  const handleFetchForms = async () => {
    genericApiToaster(
      fetchForms,
      [],
      '',
      t('errorMessages.cannotLoadForms'),
      showToast,
      hideToast,
      t,
      setForms
    );
  };

  // Fetch forms on component mount
  useEffect(() => {
    handleFetchForms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle form selection change
  const handleFormChange = (event) => {
    setSelectedFormId(event.target.value);
  };

  return (
    <Box component="form" sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* Form Selection */}
      <Select
        value={selectedFormId}
        onChange={handleFormChange}
        fullWidth
        required
        displayEmpty
        disabled={!!row}
        sx={{ fontSize: isSmallScreen ? 12 : {}, maxHeight: isSmallScreen ? 40 : {} }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
              overflowY: 'auto',
            },
            sx: {
              ...scrollbarStyle,
            },
          },
        }}
      >
        <MenuItem value="" disabled sx={{ fontSize: isSmallScreen ? 12 : {} }}>
          {t('pages.shareableFormsPage.selectForm')}
        </MenuItem>
        {forms.map((form) => (
          <MenuItem
            key={form.id}
            value={form.id}
            sx={{ fontSize: isSmallScreen ? 12 : {} }}
          >
            {form.title}
          </MenuItem>
        ))}
      </Select>
      {!selectedFormId && (
        <FormHelperText error>{t('formControl.formRequired')}</FormHelperText>
      )}

      {/* Shareable Form Settings */}
      {selectedFormId && (
        <LinkGenerationOptions
          formId={selectedFormId}
          hideModal={hideModal}
          fetchData={handleFetchFormsSharableByGeneratedBy}
          isNewShareableForm={!row} // Pass true if creating
          isUpdate={!!row} // Pass true if updating
          existingData={row || null} // Pass existing data if updating
          mode={mode} // Pass the mode (survey or shareableForm)
        />
      )}
    </Box>
  );
}

AddShareableForm.propTypes = {
  hideModal: PropTypes.func,
  handleFetchFormsSharableByGeneratedBy: PropTypes.func,
  row: PropTypes.object,
  mode: PropTypes.oneOf(['survey', 'shareableForm']),
};

export default AddShareableForm;
